import React from "react";
import cx from "clsx";
import classes from "../sass/Title.module.scss";

export function Title({ children, className, leftAdornment }) {
  return (
    <h3 className={cx(classes.root, className)}>
      {leftAdornment}
      {children}
    </h3>
  );
}
